import {Theme} from '../theme/lightTheme';
import {Platform} from 'react-native';
import {marked} from 'marked';
import {isUrl} from './helpers';

export const fixHtml = (
  html: string,
  theme?: Theme,
  isArticle?: boolean,
  isRTL?: boolean,
  fontSize?: number,
  isSeeMoreArticle?: boolean,
) => {
  let contentHtml = `<div class="content-container">${html}</div>`;
  contentHtml = contentHtml.replace(/<table/g, '<div class="wrapper"><table');
  contentHtml = contentHtml.replace(/<\/table>/g, '</table></div>');
  return `<!DOCTYPE html>
<html>
<head>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=Edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <script>
        function absorbEvent_(event) {
            var e = event || window.event;
            e.preventDefault && e.preventDefault();
            e.stopPropagation && e.stopPropagation();
            e.cancelBubble = true;
            e.returnValue = false;
            return false;
        }

        function preventLongPressMenu(node) {
            node.ontouchstart = absorbEvent_;
            node.ontouchmove = absorbEvent_;
            node.ontouchend = absorbEvent_;
            node.ontouchcancel = absorbEvent_;
        }

        function init() {
            preventLongPressMenu(document.getElementByTagName('body img'));
        }
    </script>
</head>

<body onload="init()" style="overflow: hidden; padding:${
    isSeeMoreArticle ? '3% 5%' : '16px'
  };padding-right: ${isSeeMoreArticle ? 30 : 16}px;direction:${
    isRTL ? 'rtl' : 'ltr'
  };
        text-align:${isRTL ? 'right' : 'left'};
        background-color: ${isArticle ? 'transparent' : theme?.homeBackground};">
    <style>
    ${getFontFaceRules()}
        *:not(input):not(textarea) {
            /* disable selection/Copy of UIWebView */
            -webkit-touch-callout: none;
            /* disable the IOS popup when long-press on a link */
        }
        
        * {
            font-family: "Helvetica", sans-serif;
            margin: 0;
            box-sizing: border-box;
        }
        
        body {
            line-height: 1.5;
            color: ${theme?.text?.dark};
            max-width: 100%;
        }
        
        .content-container {
            padding-bottom: 16px;
        }

        img {
            width: 100%;
            object-fit: contain;
            border-radius: 6px;
            margin: 12px 0;
        }
        
        a {
            font-weight: 600;
            color: ${theme?.primary};
            text-decoration-color: ${theme?.primary};
            text-decoration: underline;
            padding: 2px 0;
        }
        
        /* Typography */
        p, span, ul, li {
            word-break: break-word;
            font-size: ${fontSize ? fontSize + 2 + 'px' : theme?.text?.s7 + 'px'};
            line-height: ${(fontSize ? fontSize + 2 : theme?.text?.s7 || 1) * 1.5}px;
            margin-bottom: 16px;
            color: ${theme?.text?.dark};
        }
        
        /* Headings with larger margins */
        h1, h2, h3, h4, h5, h6 {
            word-break: break-word;
            line-height: 1.3;
            margin-top: 28px;
            margin-bottom: 16px;
            font-weight: 600;
        }
        
        h1 {
            font-size: ${(fontSize ? fontSize + 2 : theme?.text?.s7 || 16) * 1.8}px;
        }
        
        h2 {
            font-size: ${(fontSize ? fontSize + 2 : theme?.text?.s7 || 16) * 1.5}px;
        }
        
        h3 {
            font-size: ${(fontSize ? fontSize + 2 : theme?.text?.s7 || 16) * 1.3}px;
        }
        
        /* Lists */
        ul, ol {
            padding-left: 24px;
            margin-bottom: 16px;
        }
        
        li {
            margin-bottom: 8px;
        }
        
        li:last-child {
            margin-bottom: 0;
        }
        
        /* Tables */
        td p, td span {
            word-break: normal;
            margin-bottom: 0;
        }
        
        strong, b {
            font-weight: 700;
            color: ${theme?.text?.dark ? theme.text.dark : '#000'};
            letter-spacing: 0.01em;
            font-size: ${fontSize ? fontSize + 3 : (theme?.text?.s7 || 16) + 1}px;
        }
        
        .wrapper {
            overflow-x: auto;
            margin: 16px 0;
            border-radius: 6px;
        }
        
        .wrapper table {
            border-collapse: collapse;
            width: 100%;
        }
        
        .wrapper td, .wrapper th {
            border: 1px solid #e0e0e0;
            padding: 12px;
        }
        
        .wrapper th {
            background-color: ${theme?.primary ? `${theme.primary}22` : '#f5f5f5'};
            font-weight: 600;
        }
        
        /* Blockquotes */
        blockquote {
            border-left: 4px solid ${theme?.primary || '#ccc'};
            padding-left: 16px;
            margin: 16px 0;
            color: ${theme?.text?.dark ? theme.text.dark + 'cc' : '#555'};
            font-style: italic;
        }
        
        /* Code blocks */
        pre, code {
            font-family: 'Menlo', 'Monaco', 'Courier New', monospace;
            background-color: ${theme?.homeBackground ? theme.homeBackground + '22' : '#f5f5f5'};
            padding: 4px;
            border-radius: 4px;
            font-size: ${(fontSize ? fontSize : theme?.text?.s7 || 16) - 1}px;
        }
        
        pre {
            padding: 12px;
            overflow-x: auto;
            margin: 16px 0;
        }
        
        pre code {
            padding: 0;
            background-color: transparent;
        }
    </style>
    ${contentHtml}
</body>

</html>`;
};

// Function to get font source based on platform
const getFontFaceRules = () => {
  const isAndroid = Platform.OS === 'android';
  const basePath = isAndroid ? 'file:///android_asset/fonts/' : '';

  return `
    @font-face {
      font-family: 'Helvetica';
      src: url('${basePath}Helvetica.ttf') format('truetype');
      font-weight: 400;
    }
    @font-face {
      font-family: 'Helvetica';
      src: url('${basePath}Helvetica-Bold.ttf') format('truetype');
      font-weight: bold;
    }
    @font-face {
      font-family: 'Helvetica';
      src: url('${basePath}HelveticaNeue.ttf') format('truetype');
      font-weight: 500;
    }
  `;
};

export interface ArticleOptionProps {
  theme?: Theme;
  isArticle?: boolean;
  isSeeMoreArticle?: boolean;
  isRTL?: boolean;
  fontSize?: number;
}

/**
 * Wraps valid URLs in the provided text with <a> tags.
 *
 * @param {string} text - Input text containing URLs.
 * @returns {string} HTML string with URLs wrapped in <a> tags.
 */
export const wrapUrls = (text: string): string => {
  const urlPattern =
    /(\b(?:https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:.;,]*[-A-Z0-9+&@#/%=~_|]\b)|(\bwww\.[-A-Z0-9+&@#/%?=~_|!:.;,]*[-A-Z0-9+&@#/%=~_|]\b)/gi;
  return text?.replace(urlPattern, match => {
    let href = match.startsWith('www.') ? `https://${match}` : match;
    if (href.endsWith('/')) {
      href = href.slice(-1);
    }
    return `<a href="${href}" rel="noopener noreferrer">${match}</a>`;
  });
};

/**
 * Wraps URLs in the provided markdown string with a specific Markdown schema.
 * - If URL is preceded by [NUMBER], wraps as [[NUMBER] URL](URL)
 * - Otherwise, wraps as [URL](URL)
 * - Preserves trailing '/' in URLs
 * - Ignores URLs already in Markdown link format [text](url)
 *
 * @param {string} markdown - The input markdown string containing URLs.
 * @returns {string} - The markdown string with URLs wrapped accordingly.
 */
export const wrapUrlsWithMarkdownSchema = (markdown: string): string => {
  // Regular expression to find URLs with an optional [NUMBER] prefix
  const urlRegex = /(?:\[(\d+)\]\s*)?(https?:\/\/[^\s\]]+|www\.[^\s\]]+)/gi;

  return markdown.replace(
    urlRegex,
    (match, number, url, offset, entireString) => {
      // Determine the character before the match
      const beforeMatch = entireString.slice(0, offset);
      const charBefore = beforeMatch.slice(-2); // Get last two characters before the match

      // Check if the URL is already part of a Markdown link [text](url)
      const isAlreadyLinked = charBefore === '](';

      if (isAlreadyLinked) {
        // Do not modify URLs that are already linked
        return match;
      }

      // Validate the URL
      const href = url.startsWith('www.') ? `http://${url}` : url; // Ensure URLs starting with 'www.' have a protocol

      if (isUrl(href)) {
        // Remove any trailing punctuation from the URL (e.g., '.', ',', '!', '?', ')')
        const trailingPunctuationMatch = href.match(/[.,!?)]$/);
        const trailingPunctuation = trailingPunctuationMatch
          ? trailingPunctuationMatch[0]
          : '';
        const cleanUrl = trailingPunctuation ? href.slice(0, -1) : href;

        if (number) {
          // Wrap URLs with [NUMBER] prefix as [[NUMBER] URL](URL)
          // Example: [5] https://example.com/ => [[5] https://example.com/](https://example.com/)
          return `[[${number}] ${cleanUrl}](${cleanUrl})${trailingPunctuation}`;
        } else {
          // Wrap URLs without [NUMBER] prefix as [URL](URL)
          // Example: https://example.com/ => [https://example.com/](https://example.com/)
          return `[${cleanUrl}](${cleanUrl})${trailingPunctuation}`;
        }
      } else {
        // If it's not a valid URL, return the match as is
        return match;
      }
    },
  );
};

/**
 * Determines whether a string contains valid HTML.
 *
 * @param {string} content - The input string to check.
 * @returns {boolean} True if the content contains valid HTML; otherwise, false.
 */
export const isHtml = (content: string): boolean => {
  if (!content || typeof content !== 'string') {
    return false;
  }
  const htmlPattern = /<([a-z][\w-]*)\b[^>]*>(.*?)<\/\1>/i; // Matches full opening/closing tags
  return htmlPattern.test(content);
};

/**
 * Determines if the content is in Markdown format.
 *
 * @param {string} content - The content string to check.
 * @returns {boolean} True if the content appears to be Markdown; otherwise, false.
 */
export const isMarkdown = (content: string): boolean => {
  const markdownPatterns = [
    /^#{1,6}\s/, // Markdown headings (#, ##, ###, etc.)
    /^\s*[-+*]\s+/, // Unordered lists (-, +, or *)
    /^\s*\d+\.\s+/, // Ordered lists (1., 2., etc.)
    /\*\*(.*?)\*\*/, // Bold (**bold**)
    /\*(.*?)\*/, // Italic (*italic*)
    /`([^`]+)`/, // Inline code (`code`)
    /^>\s+/, // Blockquotes (>)
  ];
  return markdownPatterns.some(pattern => pattern.test(content));
};

/**
 * Processes content that might contain HTML, Markdown, or plain text.
 *
 * @param {string} content - Mixed content string.
 * @returns {string} Processed HTML.
 */
export const processContent = (content: string): string => {
  if (isHtml(content)) {
    return wrapUrls(content);
  } else if (isMarkdown(content)) {
    const normalizeLineBreaks = content.replace(/\n/g, '  \n');
    return marked.parse(normalizeLineBreaks, {async: false});
  } else {
    return wrapUrls(content);
  }
};

/**
 * Main function to render sanitized and processed content in React Native.
 *
 * @param {string} content - The content string to render.
 * @param {ArticleOptionProps} options - Configuration options for rendering.
 * @returns {React.ReactElement} Rendered content.
 */
export const renderArticleContent = (
  content: string,
  options?: ArticleOptionProps,
): string => {
  const {
    isRTL = false,
    fontSize,
    theme,
    isArticle,
    isSeeMoreArticle,
  } = options || {};

  const processedContent = processContent(content);
  return fixHtml(
    processedContent,
    theme,
    isArticle,
    isRTL,
    fontSize,
    isSeeMoreArticle,
  );
};
